import PptxGenJS from "pptxgenjs";
import * as XLSX from 'xlsx'
import ExcelJS from 'exceljs';

const convertToInches = function (val: number) {
    return val / 160;
}

const printHeatMap = function (sequenceName: any, tableID: string,forMail = false) {
    const currentDate = new Date();
    //variable used in position calculation
    const margin = convertToInches(30);
    const headerHieght = convertToInches(30);
    
    var masterObjects: any = [];
    var pptx: any = new PptxGenJS();


    pptx.tableToSlides(tableID, {
        addText: { text: sequenceName+" Heat Map", options: { x: 0.5, y: 0.3, bold: true, color: "#000000", fontSize: 24, } }
    })

    var pptName = sequenceName + " Heat Map"
    if(forMail){
        return pptx.write('blob')
    }else{
        pptx.writeFile(pptName);
    }
}

export const printHeatMap2 = function (sequenceName: string, tableID: string, forMail = false) {
    return new Promise((resolve, reject) => {
        const currentDate = new Date();
        const margin = convertToInches(30);

        // Initialize PowerPoint Presentation
        const pptx = new PptxGenJS();
        pptx.defineLayout({ name: "Custom", width: 13.3, height: 7.5 });
        pptx.layout = "Custom";

        // Define slide and add title text
        const slide = pptx.addSlide();
        slide.addText(
            `${sequenceName} - Heat Map`,
            { x: 0.5, y: 0.3, fontSize: 24, bold: true, color: "003366" }
        );

        // Add current date as subtitle
        slide.addText(
            `Generated on: ${currentDate.toLocaleDateString()}`,
            { x: 0.5, y: 0.8, fontSize: 14, color: "666666" }
        );

        // Get table data from HTML table element
        const table = document.getElementById(tableID) as HTMLTableElement;
        if (table) {
            const rows = Array.from(table.rows);
            const pptxTableData = rows.map(row => Array.from(row.cells).map(cell => {
                const cellStyle = window.getComputedStyle(cell);
                const backgroundColor = cellStyle.backgroundColor;

                return {
                    text: cell.textContent || "",
                    options: {
                        fontSize: 12,
                        color: "000000", // Text color
                        align: "center" as const,
                        fill: { color: backgroundColor === "rgba(0, 0, 0, 0)" ? "F1F1F1" : rgbToHex(backgroundColor as string) } // Set cell background color
                    }
                };
            }));

            // Add table to slide
            slide.addTable(pptxTableData, {
                x: 0.5,
                y: 1.2,
                colW: [2, 2, 2, 2],
                border: { pt: 1, color: "CCCCCC" }
            });
        }

        // Save as a file or return a blob for email
        if (forMail) {
            pptx.write({ outputType: "blob" })
                .then(blob => resolve(blob))
                .catch(err => reject(err));
        } else {
            pptx.writeFile({ fileName: `${sequenceName} Heat Map` });
            resolve(null); // Resolve with null since we're not sending a file
        }
    });
};

export const printHeatMapExcel = async function (sequenceName: string, tableID: string, forMail = false) {
    const currentDate = new Date();

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Projects Readiness Chart');

    // Get table data from HTML table element
    const table = document.getElementById(tableID) as HTMLTableElement;
    if (!table) {
        throw new Error("Table not found");
    }

    // Iterate over rows and cells to populate worksheet
    const rows = Array.from(table.rows);
    rows.forEach((row, rowIndex) => {
        const excelRow = worksheet.addRow([]);

        Array.from(row.cells).forEach((cell, colIndex) => {
            const cellText = cell.textContent || "";

            // Add cell value to Excel row
            const excelCell = excelRow.getCell(colIndex + 1);
            excelCell.value = cellText;

            // Get cell background color
            const cellStyle = window.getComputedStyle(cell);
            const backgroundColor = cellStyle.backgroundColor;
            const hexColor = backgroundColor === "rgba(0, 0, 0, 0)" ? "#FFFFFF" : rgbToHex2(backgroundColor as string);

            // Apply background color if it's not transparent
            if (hexColor) {
                excelCell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: hexColor.slice(1) }, // Remove # for ExcelJS
                };
            }
        });
    });

    // Export the workbook as a Blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    
    // Create a link element for downloading the file
    const fileName = `${sequenceName}_Project_Readiness_Chart_${currentDate.toLocaleDateString()}.xlsx`;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

function rgbToHex2(rgb: string): string {
    const result = rgb.match(/\d+/g);
    if (!result) return "#ffffff"; // Default to white if no color found

    const r = parseInt(result[0]);
    const g = parseInt(result[1]);
    const b = parseInt(result[2]);

    return (
        "#" +
        ((1 << 24) + (r << 16) + (g << 8) + b)
            .toString(16)
            .slice(1)
            .toUpperCase()
    );
}

// Helper function to convert RGB color to HEX
function rgbToHex(rgb: string): string {
    const result = rgb.match(/\d+/g);
    if (result) {
        const hex = result
            .map(x => {
                const hexValue = parseInt(x).toString(16);
                return hexValue.length === 1 ? "0" + hexValue : hexValue; // Ensure two digits
            })
            .join('');
        return hex.toUpperCase();
    }
    return "FFFFFF"; // Default to white if conversion fails
}

export default printHeatMap